import React from 'react';
import {
  List,
  Datagrid,
  Create,
  SimpleForm,
  EditButton,
  DeleteButton,
  TextInput,
  LongTextInput,
  Filter,
  TextField,
  ReferenceInput,
  ReferenceArrayInput,
  SelectInput,
  BooleanInput,
  ReferenceField,
  required,
  translate as t,
} from 'admin-on-rest';

import countryCodes from '../utils/country-codes';
import Edit from '../components/Edit';
import { SelectArrayInput } from '../components/inputs/SelectArrayInput';
import { getTranslationByLocale } from '../utils/TranslationUtils';
import TranslatableInput from '../components/inputs/TranslatableInput';
const IngredientFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search (desc or art.no)" source="q" alwaysOn />
  </Filter>
);

export const IngredientList = (props) => (
  <List {...props} filters={<IngredientFilter />}>
    <Datagrid>
      <TextField source="description" />
      <TextField source="supplierOrderId" />
      <ReferenceField source="supplier" reference="suppliers" linkType="show">
        <TextField source="name" />
      </ReferenceField>
      <EditButton {...props} basePath="/ingredients" />
      <DeleteButton {...props} basePath="/ingredients" />
    </Datagrid>
  </List>
);

const IngredientTitle = t(({ record, translate }) => (
  <span>{record ? translate('edit.title', { title: record.description }) : ''}</span>
));

const validateIngredient = (values) => {
  const errors = {};
  if (!values.supplier) {
    errors.supplier = ['The supplier is required'];
  }
  return errors;
};

const Form = t((props) => (
  <SimpleForm {...props} validate={validateIngredient} redirect="list">
    <BooleanInput source="edible" defaultValue label={props.translate('resources.ingredients.fields.edible')} />
    <LongTextInput source="contents" label={props.translate('resources.products.fields.listOfContent')} />
    <LongTextInput source="description" label={props.translate('resources.ingredients.fields.description')} validate={[required]} />
    <ReferenceArrayInput {...props} source="allergens" label={props.translate('resources.products.fields.allergens')} reference="allergens" allowEmpty>
      <SelectArrayInput optionText={(choice) => getTranslationByLocale(choice.title, props.locale)} options={{ fullWidth: true }} />
    </ReferenceArrayInput>
    <ReferenceInput source="supplier" reference="suppliers" allowEmpty validate={[required]}>
      <SelectInput optionText="name" options={{ fullWidth: true }} validate={[required]} />
    </ReferenceInput>
    <TextInput source="supplierOrderId" options={{ fullWidth: true }} validate={[required]} />
    <SelectInput
      source="originCountryCode"
      options={{ fullWidth: true }}
      choices={[{ id: 'EU', name: 'EU' }, ...countryCodes]}
    />
    <TranslatableInput source="displayName" />
  </SimpleForm>
));

export const IngredientEdit = (props) => (
  <Edit title={<IngredientTitle />} {...props}>
    <Form {...props} />
  </Edit>
);

export const IngredientCreate = (props) => (
  <Create {...props}>
    <Form {...props} />
  </Create>
);
